
	import useDoctor from "@/store/DoctorState";
import { defineComponent, onMounted,
// PropType,
ref, watchEffect } from "vue";
	import { ChartV2 } from "../helpers/chart.v2";
	import HealthIcon from "@/assets/HealthIcon.vue";
	import LungIcon from "@/assets/LungIcon.vue";
	import ThermometerIcon from "@/assets/ThermometerIcon.vue";
	/* import ThermometerFilledIcon from "@/assets/ThermometerFilledIcon.vue"; */
	import PercentageIcon from "@/assets/PercentageIcon.vue";

  const thresholdMin = 2; //5;
  const avg = (arr : number[]) => arr.reduce( ( p, c ) => p + c, 0 ) / arr.length;
  function reduceNearbyPoints(acc : any[], item : any) {
    if (acc.length === 0) return [item];

    const lastIndex = acc.length - 1;
    const prev = acc[lastIndex];

    // delta in seconds
    let deltaTime = item.epoch - prev.epoch;

    // in minutes
    deltaTime = deltaTime / 60;

    if (!acc[lastIndex].sinceEpoch) acc[lastIndex].sinceEpoch = prev.epoch

    let deltaTimeSinceEpoch = (item.epoch - acc[lastIndex].sinceEpoch) / 60;

    if (deltaTime < thresholdMin && deltaTimeSinceEpoch < thresholdMin) {
      acc[lastIndex] = {
        ...acc[lastIndex],
        value: avg([prev.value, item.value]),
        epoch: Math.floor(avg([prev.epoch, item.epoch]))
      }
    } else {
      acc.push(item)
    }

    return acc;
  }

	export default defineComponent({
    components: {
      HealthIcon, LungIcon, ThermometerIcon, PercentageIcon,
    },
		setup() {
			const { patientSelected, watchSensorValuesFromPatient } = useDoctor();
			const patientId = patientSelected.value?.id
			let records = ref<MeasurementRecord[]>([])
			
			if (patientId)
				records = watchSensorValuesFromPatient(patientId!)

			const chart = ref<any>(null);
			let sensorO2El = ref(null);
			let sensorfrecRespEl = ref(null);
			let sensorTempEl = ref(null);
			let sensorFrecCardEl = ref(null);
			// let lastRecords = 0; skipped in order to return all sensor values
			onMounted(async () => {
				// Create a new line chart object where as first parameter we pass in a selector
				// that is resolving to our chart container element. The Second parameter
				// is the actual data object.
				let satO2Plot: ChartV2 = new ChartV2(sensorO2El.value!, {
							upperLimit: 93,
							lowerLimit: 89,

							yAxisMin: 60,
							yAxisMax: 100,
							tooltip: { name: 'Sat. O2' }
				});
				let frecRespPlot: ChartV2 = new ChartV2(sensorfrecRespEl.value!, {
							upperLimit: 30,
							lowerLimit: 20,

							yAxisMin: 10,
							yAxisMax: 36,
							tooltip: { name: 'Frec. Resp.' }
				});
				let frecCardPlot: ChartV2 = new ChartV2(sensorFrecCardEl.value!, {
							upperLimit: 130,
							lowerLimit: 100,

							yAxisMin: 60,
							yAxisMax: 140,
							tooltip: { name: 'Frec. Card.' }
				});
				let tempPlot: ChartV2 = new ChartV2(sensorTempEl.value!, {
							upperLimit: 40,
							lowerLimit: 38,

							yAxisMin: 35,
							yAxisMax: 42,
							tooltip: { name: 'Temp.' }
				});
				watchEffect(() => {
					if (records.value.length === 0) return;
					const _records = records.value?.reduce(
						(acc: any, e) => {
							if (e.satO2 !== null) {
								acc.sato2.push({
									epoch: (e.dateTime as any).seconds,
									value: e.satO2,
								});
							}

							if (e.frecResp !== null) {
								acc.frecResp.push({
									epoch: (e.dateTime as any).seconds,
									value: e.frecResp,
								});
							}

							if (e.temp !== null) {
								acc.temp.push({
									epoch: (e.dateTime as any).seconds,
									value: e.temp,
								});
							}

							if (e.frecCard !== null) {
								acc.frecCard.push({
									epoch: (e.dateTime as any).seconds,
									value: e.frecCard,
								});
							}

							return acc;
						},
						{
							sato2: [],
							frecResp: [],
							frecCard: [],
							temp: [],
						}
					);
					
					satO2Plot.draw(_records.sato2.reduce(reduceNearbyPoints, []))
					frecRespPlot.draw(_records.frecResp.reduce(reduceNearbyPoints, []))
					frecCardPlot.draw(_records.frecCard.reduce(reduceNearbyPoints, []))
					tempPlot.draw(_records.temp.reduce(reduceNearbyPoints, []))
				});
			});
			return {
				chart,
				sensorO2El,
				sensorfrecRespEl,
				sensorTempEl,
				sensorFrecCardEl,
				records,
			};
		},
	});
